import { render, staticRenderFns } from "./list-responses.vue?vue&type=template&id=0bda9919&scoped=true"
import script from "./list-responses.vue?vue&type=script&lang=js"
export * from "./list-responses.vue?vue&type=script&lang=js"
import style0 from "./list-responses.vue?vue&type=style&index=0&id=0bda9919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda9919",
  null
  
)

export default component.exports